import { CdkTextareaAutosize, TextFieldModule } from '@angular/cdk/text-field';
import { ChangeDetectionStrategy, Component, HostBinding, ViewChild, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { RichTextEditorComponent } from 'shared/feature-rich-text-editor';
import { CheckboxComponent } from 'shared/ui-common';

import { FlowchartElementType } from '@treetop/shared/model';

@Component({
  standalone: true,
  selector: 'sidebar-title-description',
  templateUrl: './title-description.component.html',
  styleUrls: ['./title-description.component.scss'],
  imports: [FormsModule, TranslocoModule, TextFieldModule, MatTooltipModule, RichTextEditorComponent, CheckboxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleDescriptionComponent {
  public title = input<string>('');
  public description = model<string>('');
  public showDescription = model<boolean>(false);

  public showCheckbox = input<boolean>(true);
  public disableDescription = input<boolean>(false);
  public onReset = input<boolean>(false);
  public readonly = input<boolean>(false);
  public testId = input<string>('');

  public titleChange = output<string>();

  protected onTitleChange(value: string): void {
    this.titleChange.emit(value.trim());
  }

  @HostBinding('class.readonly')
  public get hostReadonly() {
    return this.readonly();
  }

  @ViewChild('autosizeDescription') protected autosize: CdkTextareaAutosize;
  @ViewChild('autosizeTitle') protected autosizeTitle: CdkTextareaAutosize;

  protected FlowchartElementType = FlowchartElementType;
}
